<template>
  <app-card
    class="transition-shadow duration-300 md:border md:hover:shadow-lg"
    tag="section"
  >
    <app-expandable class="grid" :disabled="!isExpandable" :model-value="true">
      <template #trigger="{ open }">
        <header class="pb-6 md:px-8 md:py-6">
          <h3 class="flex items-center gap-4 text-left text-xl font-extrabold">
            <app-icon :icon="entry.icon" :size="32" />

            {{ entry.title }}

            <span v-if="isExpandable" class="flex-auto text-right">
              <app-icon
                class="transition"
                :class="{ 'rotate-180': open }"
                icon="ph:caret-down"
              />
            </span>
          </h3>
        </header>
      </template>

      <ol
        v-if="entry.chapters.length > 0"
        class="relative grid gap-7 overflow-hidden pb-6 md:px-8"
      >
        <li
          v-for="(chapter, index) in entry.chapters"
          :key="chapter.id!"
          class="relative z-0"
          :class="{
            'before:absolute before:-bottom-10 before:left-[11px] before:top-2 before:-z-10 before:block before:border-l-2 before:border-dotted before:border-black':
              index !== entry.chapters.length - 1,
          }"
        >
          <div class="grid">
            <p class="flex items-start gap-2 text-left font-bold">
              <app-icon class="shrink-0 bg-white" icon="ph:check-circle" />
              {{ chapter.title }}
            </p>

            <ol class="grid gap-3 pl-8 pt-3">
              <li
                v-for="(section, sectionIndex) in chapter.sections"
                :key="section.id!"
              >
                <course-program-section
                  :index="sectionIndex + 1"
                  :section="section"
                />
              </li>
            </ol>
          </div>
        </li>
      </ol>
    </app-expandable>
  </app-card>
</template>

<script lang="ts" setup>
import CourseProgramSection from "~/business-areas/course-program/component/course-program-section.vue";
import type { CourseProgramEnhancedEntryView } from "~/business-areas/course-program/composables/course-program-enhanced.hook";

const properties = defineProps<{
  entry: CourseProgramEnhancedEntryView;
}>();

const isExpandable = computed(() => properties.entry.chapters.length > 0);
</script>
